<script setup lang="ts">
import { useAppUpdate } from '@stl/composables/appUpdate';
import { useRoute } from 'vue-router';

withDefaults(defineProps<{ appName?: string }>(), { appName: 'app' });

const $route = useRoute();
const { updateAvailable } = useAppUpdate();
</script>

<template lang="pug">
.alert.alert-info.my-0.px-3.text-center(v-if="updateAvailable") A new version of the {{ appName }} is available.
  a.btn.btn-link.ms-3(:href="$route.fullPath") Reload
</template>
